import type { PumsemChangeKind } from '../model/pumsem.type';

/**
 * 품셈 화면의 공용 클래스 문자열.
 *
 * 검색 결과 카드·상세 표·비교 화면이 **같은 문자열**을 봐야 "이번 판 개정" 표기가
 * 화면마다 다른 색으로 보이지 않는다(도움말 `blockStyles` 와 같은 이유).
 */

/** 개정 표기. 색만 쓰지 않고 라벨을 함께 둔다 — 인쇄·색약에서 색은 사라진다. */
export const CHANGE_STYLE: Record<
  PumsemChangeKind,
  { label: string; chip: string } | null
> = {
  NEW: {
    label: '신설',
    chip: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300',
  },
  AMENDED: {
    label: '개정',
    chip: 'bg-warning/15 text-amber-700 dark:bg-warning/15 dark:text-amber-300',
  },
  REMOVED: {
    label: '삭제',
    chip: 'bg-danger/10 text-danger dark:bg-danger/15 dark:text-red-300',
  },
  // 안 바뀐 항목에 "변경 없음" 배지를 달면 화면이 배지로 뒤덮인다.
  UNCHANGED: null,
};

/**
 * 값이 바뀐 셀. **밑줄이 본체이고 배경은 거들 뿐이다** — 신구조문대비표가 밑줄로
 * 표시해 온 관례이기도 하고, 색만 쓰면 인쇄물과 색약 사용자에게 아무 정보가 없다.
 */
export const CHANGED_CELL =
  'underline decoration-amber-600 decoration-2 underline-offset-4 dark:decoration-amber-400';

/** 표 셀 공통. 수치는 자릿수가 맞아야 읽히므로 tabular-nums 가 필수다. */
export const TABLE_CELL =
  'px-3.5 py-2.5 text-right tabular-nums whitespace-nowrap';
export const TABLE_HEAD =
  'px-3.5 py-2.5 text-right text-[14px] font-bold whitespace-nowrap text-neutral-600 dark:text-neutral-300';
export const TABLE_ROW_LABEL =
  'px-3.5 py-2.5 text-left font-medium whitespace-nowrap';
/**
 * 세로 병합 칸. 표에 세로 괘선이 없어서, 옆 칸과 선을 그어야 여러 행에 걸친
 * 한 칸으로 읽힌다(발행본도 병합 칸 양옆에 선을 긋는다).
 */
export const SPANNED_CELL =
  'align-middle border-x border-neutral-100 dark:border-white/8';
